// ============================================
// GLOBAL TOAST FUNCTION
// ============================================

import type { ToastAction } from '../types';

export function initGlobalToast(): void {
    (window as any).mdToast = (message: string, type: string = 'default', duration: number = 4000, action: ToastAction | null = null, title?: string) => {
        const event = new CustomEvent('md-toast', {
            detail: { message, type, duration, action, title }
        });
        window.dispatchEvent(event);
    };
}
